// Base link interface that any link-like object must have
type BaseLinkType = {
  type?: ('reference' | 'custom' | 'chat' | 'jumpToBlock') | null
  reference?: {
    relationTo: 'pages' | 'posts' | 'webinars' | 'platform-engineering-unplugged'
    value: string | { slug?: string | null }
  } | null
  url?: string | null
  anchorId?: string | null
}

export function resolveHref(link: BaseLinkType | null | undefined, fallback: string = ''): string {
  if (!link) return fallback

  // Chat links don't have an href, return empty string
  if (link.type === 'chat') return ''

  // Jump to block links generate anchor links
  if (link.type === 'jumpToBlock') {
    if (link.anchorId) {
      return `#${link.anchorId}`
    }
    return ''
  }

  if (
    link.type === 'reference' &&
    link.reference &&
    typeof link.reference.value === 'object' &&
    'slug' in link.reference.value &&
    link.reference.value.slug
  ) {
    const relationPrefix = link.reference.relationTo !== 'pages' ? `/${link.reference.relationTo}` : ''
    return `${relationPrefix}/${link.reference.value.slug}`
  }

  return link.url || fallback
}